// provides a runtime for switching between apps (not routing within apps).
import './setupSharedEnvStore';
import initAppState from './initAppState';
import handleAppChange from './handleAppChange';

import './app.css';

handleAppChange({
  appState: initAppState(),
  domNode: document.getElementById('application'),
  navNode: document.getElementById('global-navigation')
});



// WEBPACK FOOTER //
// ./jsapp/learnRuntime/index.js